<form [formGroup]="invitedUserForm">

  <div class="form-group row">
    <label class="col-3 col-form-label">First Name </label>
    <kendo-textbox class="col-9" placeholder="First Name" name="FirstName" formControlName="firstName"
      [(ngModel)]="firstName">
    </kendo-textbox>
    @if (invitedUserForm?.controls?.firstName?.errors?.maxlength) {
      <app-error-message message="Max length is 16 chars"
      [isError]="true"></app-error-message>
    }
    @if (invitedUserForm?.controls?.firstName?.errors?.minlength) {
      <app-error-message message="Min length is 1 char"
      [isError]="true"></app-error-message>
    }
    @if (!invitedUserForm?.controls?.firstName?.errors?.required && invitedUserForm?.controls?.firstName?.errors?.cannotContainSpaceOnly) {
      <app-error-message message="Name can't contain space only"
      [isError]="true"></app-error-message>
    }
    @if (invitedUserForm?.controls?.firstName?.errors?.cannotStartWithWhiteSpace) {
      <app-error-message message="Name can't start with white space"
      [isError]="true"></app-error-message>
    }
    @if (invitedUserForm?.controls?.firstName?.errors?.cannotEndWithWhiteSpace) {
      <app-error-message message="Name can't end with white space"
      [isError]="true"></app-error-message>
    }
    @if (invitedUserForm?.controls?.firstName?.errors?.cannotBeNumbersOnly) {
      <app-error-message message="Name can't be numbers only"
      [isError]="true"></app-error-message>
    }
    @if (invitedUserForm?.controls?.firstName?.errors?.cannotBeSpecialCharsOnly) {
      <app-error-message message="Name can't be special chars only"
      [isError]="true"></app-error-message>
    }
  </div>
  <div class="form-group row">
    <label class="col-3 col-form-label">Last Name </label>
    <kendo-textbox class="col-9" placeholder="Last Name" name="lastName" formControlName="lastName"
      [(ngModel)]="lastName">
    </kendo-textbox>
    @if (invitedUserForm?.controls?.lastName?.errors?.maxlength) {
      <app-error-message message="Max length is 16 chars"
      [isError]="true"></app-error-message>
    }
    @if ( invitedUserForm?.controls?.lastName?.errors?.minlength) {
      <app-error-message message="Min length is 1 char"
      [isError]="true"></app-error-message>
    }
    @if ( invitedUserForm?.controls?.lastName?.errors?.cannotContainSpaceOnly) {
      <app-error-message message="Name can't contain space only"
      [isError]="true"></app-error-message>
    }
    @if ( invitedUserForm?.controls?.lastName?.errors?.cannotStartWithWhiteSpace) {
      <app-error-message message="Name can't start with white space"
      [isError]="true"></app-error-message>
    }
    @if ( invitedUserForm?.controls?.lastName?.errors?.cannotEndWithWhiteSpace) {
      <app-error-message message="Name can't end with white space"
      [isError]="true"></app-error-message>
    }
    @if ( invitedUserForm?.controls?.lastName?.errors?.cannotBeNumbersOnly) {
      <app-error-message message="Name can't be numbers only"
      [isError]="true"></app-error-message>
    }
    @if ( invitedUserForm?.controls?.lastName?.errors?.cannotBeSpecialCharsOnly) {
      <app-error-message message="Name can't be special chars only"
      [isError]="true"></app-error-message>
    }
  </div>
  <div class="form-group row">
    <label class="col-3 col-form-label">Region </label>
    <kendo-textbox class="col-9" placeholder="Region" name="region" formControlName="region" [(ngModel)]="region">
    </kendo-textbox>
    @if (invitedUserForm?.controls?.region?.errors?.maxlength) {
      <app-error-message message="Max length is 45 chars"
      [isError]="true"></app-error-message>
    }
    @if (invitedUserForm?.controls?.region?.errors?.minlength) {
      <app-error-message message="Min length is 1 char"
      [isError]="true"></app-error-message>
    }
    @if (invitedUserForm?.controls?.region?.errors?.cannotContainSpaceOnly) {
      <app-error-message message="Region Name can't contain space only"
      [isError]="true"></app-error-message>
    }
    @if (invitedUserForm?.controls?.region?.errors?.cannotStartWithWhiteSpace) {
      <app-error-message message="Region Name can't start with white space"
      [isError]="true"></app-error-message>
    }
    @if (invitedUserForm?.controls?.region?.errors?.cannotEndWithWhiteSpace) {
      <app-error-message message="Region Name can't end with white space"
      [isError]="true"></app-error-message>
    }
    @if (invitedUserForm?.controls?.region?.errors?.cannotBeNumbersOnly) {
      <app-error-message message="Region Name can't be numbers only"
      [isError]="true"></app-error-message>
    }
    @if (invitedUserForm?.controls?.region?.errors?.cannotBeSpecialCharsOnly) {
      <app-error-message message="Region Name can't be special chars only"
      [isError]="true"></app-error-message>
    }
  </div>
  <div class="form-group row">
    <label class="col-3 col-form-label">Title </label>
    <kendo-textbox class="col-9" placeholder="Title" name="title" formControlName="title" [(ngModel)]="title">
    </kendo-textbox>
    @if (invitedUserForm?.controls?.title?.errors?.maxlength) {
      <app-error-message message="Max length is 45 chars"
      [isError]="true"></app-error-message>
    }
    @if (invitedUserForm?.controls?.title?.errors?.minlength) {
      <app-error-message message="Min length is 1 char"
      [isError]="true"></app-error-message>
    }
    @if (invitedUserForm?.controls?.title?.errors?.cannotContainSpaceOnly) {
      <app-error-message message="Title can't contain space only"
      [isError]="true"></app-error-message>
    }
    @if (invitedUserForm?.controls?.title?.errors?.cannotStartWithWhiteSpace) {
      <app-error-message message="Title can't start with white space"
      [isError]="true"></app-error-message>
    }
    @if (invitedUserForm?.controls?.title?.errors?.cannotEndWithWhiteSpace) {
      <app-error-message message="Title can't end with white space"
      [isError]="true"></app-error-message>
    }
    @if (invitedUserForm?.controls?.title?.errors?.cannotBeNumbersOnly) {
      <app-error-message message="Title can't be numbers only"
      [isError]="true"></app-error-message>
    }
    @if (invitedUserForm?.controls?.title?.errors?.cannotBeSpecialCharsOnly) {
      <app-error-message message="Title can't be special chars only"
      [isError]="true"></app-error-message>
    }
  </div>

  <div class="form-group row">
    <label class="col-3 col-form-label">Email <span class="astric">*</span></label>
    <kendo-textbox class="col-9" formControlName="email" placeholder="Email" name="Email" [(ngModel)]="Email" >
    </kendo-textbox>
    <app-error-message [message]="emailError" [isError]="true"></app-error-message>

    @if (invitedUserForm?.controls?.email?.errors?.maxlength) {
      <app-error-message message="Max length is 64 chars"
      [isError]="true"></app-error-message>
    }

  </div>

  <div class="form-group row">
    <label class="col-3 col-form-label">Phone </label>

    <kendo-maskedtextbox class="col-9 form-control" [(ngModel)]="phone" formControlName="phone" mask="+000 - 0000000000"></kendo-maskedtextbox>
    @if (invitedUserForm?.controls?.phone?.errors?.maxlength) {
      <app-error-message message="Max length is 45 chars"
      [isError]="true"></app-error-message>
    }

  </div>
  <div class="form-group row">
    <label class="col-3 col-form-label">Company Type<span class="astric">*</span></label>
    <app-dropdown-list class="col-9" [data]="CompanyTypes" textField="companyTypeName" valueField="companyTypeId"
      [valuePrimitive]="true" (selectionChange)="getSelectedCompanyTypeItem($event)" [selectedItem]="companyId">
    </app-dropdown-list>
    <app-error-message [message]="companyTypeError" [isError]="true"></app-error-message>
  </div>

  <div class="form-group row">
    <label class="col-3 col-form-label">Company <span class="astric">*</span></label>

    <kendo-dropdownlist defaultItem="Select Value" class="col-9" [filterable]="true" [data]="CompanyList"
      textField="name" valueField="id" formControlName="Company"  (selectionChange)="companyChange($event)"
      (filterChange)="click($event)">
    </kendo-dropdownlist>
    <app-error-message [message]="companyError" [isError]="true"></app-error-message>
  </div>
  <div class="form-group row">
    <label class="col-3 col-form-label">CM Site<span class="astric">*</span></label>
    <kendo-dropdownlist [disabled]="CmSiteDisabled" defaultItem="Select Value" class="col-9" [filterable]="true"
      [data]="cmSiteListItems" textField="cmSiteName" valueField="cmSiteId"
      (filterChange)="handleFilterCMsite($event)"
      formControlName="cmSite"
      (valueChange)="cmSite = $event"
      >
    </kendo-dropdownlist>
    <app-error-message [message]="cmSiteError" [isError]="true"></app-error-message>
  </div>

  <div class="form-group row">
    <label class="col-3 col-form-label">Role<span class="astric">*</span></label>
    <app-dropdown-list class="col-9" [data]="RolelistItems" textField="roleName" valueField="roleId"
      [valuePrimitive]="true" (selectionChange)="getSelectedRole($event)" [selectedItem]="role">
    </app-dropdown-list>
    <app-error-message [message]="roleError" [isError]="true"></app-error-message>
  </div>

  @if (this.IsError) {
    <app-error-message message="{{ error }}" [isError]="true"></app-error-message>
  }


</form>